<div class="user-details-container">
  <div class="header-container" *ngIf="showHeader">
    <img
      class="icon-closed"
      src="/assets/icons/icon-closed.svg"
      alt="close"
      (click)="close()"
    />
  </div>

  <mat-progress-bar
    *ngIf="loading"
    mode="indeterminate"
    class="effect-mid"
  ></mat-progress-bar>

  <div class="profile-container" *ngIf="user && !loading">
    <img class="profile-image" src="{{ user.photo }}" alt="avatar" />
    <div class="profile-user-name">
      <span class="profile-user-name-text title-color">
        {{ user.firstName }} {{ user.lastName }}
      </span>
    </div>
    <div class="profile-name">
      <span class="profile-name-text">
        {{ user.profiles }}
      </span>
    </div>
  </div>

  <app-children-details *ngIf="user && isStudent" [user]="user"></app-children-details>
  <app-parents-details *ngIf="user && !isStudent" [user]="user"></app-parents-details>

</div>
